import 'normalize.css/normalize.css';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/style/index.web.tsx
 **/